import React, { lazy, Suspense } from 'react';
import { Box } from '@react-three/drei';
import Glass from './FrameComp/Glass';
import ChangeDepths from '../Helpers/ChangeDepths.jsx';
// import Splines from './FrameComp/BoxFrame/Splines.jsx';

// Lazy load BoxProfile
const BoxProfile = lazy(() => import('./FrameComp/BoxFrame/BoxProfile'));

// Loading placeholder
const LoadingPlaceholder = () => (
  <Box args={[1, 1, 1]} position={[0, 0, 0]}>
    <meshStandardMaterial color="gray" opacity={0.5} transparent />
  </Box>
);

export default function BoxFrame() {
  const { glyphDepth, glassDepth } = ChangeDepths();

  const glassInsert = 0.6;

  return (
    <>
      <Suspense fallback={<LoadingPlaceholder />}>
        <BoxProfile
          glassInsert={glassInsert}
          glyphDepth={glyphDepth}
        />
      </Suspense>
      <Glass glassDepth={glassDepth} />
      {/* <Splines /> */}
    </>
  );
}